import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Buffer } from "buffer";
import { validateGuid } from "../services/apiService";
import ContractPreviewPDF from "../components/ContractPreviewPDF";
import Button from "../components/Button";
import Container from "../components/Container";
import Content from "../components/Content";
import { Row, Card, Col, FormCheck } from "react-bootstrap";
import Label from "../components/Label";
import { getHeadersAPI } from "../api/ServicesConfiguration";

function WaiverPageV2() {
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const guid = queryParameters.get("guid");

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFile, setIsLoadingFile] = useState(true);

  if (!guid) {
    navigate('/ErrorPage');
  }

  // FetchData
  const fetchData = async () => {
    if (!(await validateGuid(guid!))) {
      navigate('/ErrorPage');
    }
  };

  //Run 1 time
  useEffect(() => {
    if (!guid) {
      navigate('/ErrorPage');
    } else {
      fetchData();
    }
  }, []);

  async function signOnClick() {
    setIsLoading(true);
    let link: any;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/signContractWaiver/${guid}`,
        {},
        { headers: await getHeadersAPI() }
      );

      link = response.data;
    
    } catch (error) {
      alert(error);
      setIsLoading(false);
    }

    setIsLoading(false);
    window.location.href = link;
  }
  return (
    <div>
      <div className="content mt-5">
        <div className="container">
          <Card className="p-5">
            <Row className="mb-4">
              <Col>
                <h1 className="m-0 form-header">
                  Veertien dagen bedenktijd private lease
                </h1>
              </Col>
            </Row>
            <p>
              <h5>
                <b>
                  Binnen 14 dagen kosteloos ontbinden van het private
                  leasecontract
                </b>
              </h5>
              <div>
                Voor het private leasecontract dat je ondertekent heb je 14
                dagen bedenktijd. Dat betekent dat je na ondertekening van het
                contract nog 14 dagen de tijd hebt om zonder kosten van de
                private lease af te zien. Je maakt dan gebruik van je
                herroepingsrecht en dat kun je doen door een e-mail te sturen
                naar het adres dat je in onze e-mails vindt.
              </div>
            </p>
            <br />
            <p>
              <h5>
                <b>Wat betekent deze bedenktijd van 14 dagen voor mij?</b>
              </h5>
              <div>
                Vanwege de bedenktijd van 14 dagen, kunnen wij de auto pas
                bestellen bij de dealer nadat de bedenktijd is verstreken. Als
                jouw leaseauto al beschikbaar is snappen we dat dit niet altijd
                handig uitkomt. In dat geval kun je ervoor kiezen om afstand te
                doen van de 14 dagen bedenktijd.
              </div>{" "}
            </p>
            <br />
            <p>
              <h5>
                <b>
                  Hoe kan ik afstand doen van de 14 dagen bedenktijd bij private
                  lease?
                </b>
              </h5>
              <div>
                Je kunt aangeven dat je geen 14 dagen bedenktijd nodig hebt door
                de “Afstandsverklaring 14 dagen bedenktijd” te ondertekenen. Dat
                kan op 2 manieren:
              </div>
              <div>
                <ul>
                  <li>
                    Je ondertekent de verklaring bij de dealer. Een tijdrovend
                    klusje want wij kunnen geen afstandsverklaring accepteren
                    die tegelijkertijd is ondertekend met het leasecontract. Dat
                    betekent terug naar de dealer, invullen en ondertekenen
                    waarna de dealer ervoor zorgt dat wij de verklaring
                    ontvangen. Dan kan de leaseauto besteld worden.{" "}
                  </li>
                  <li>
                    <u>
                      Eenvoudiger en sneller is klikken op de knop “Doorgaan”
                      onderaan deze pagina.
                    </u>
                    <p>
                      Je kunt dan de afstandsverklaring meteen lezen en digitaal
                      met iDIN ondertekenen. Wij ontvangen de ondertekende
                      verklaring meteen en dus kan ook jouw leaseauto direct
                      besteld worden.
                    </p>
                  </li>
                </ul>
              </div>
              <div>
                NB: als je de bedenktijd van 14 dagen wilt aanhouden, hoef je
                niets te doen en kun je deze pagina sluiten door te klikken op
                het kruis rechtsboven.
              </div>
            </p>

            <div className="mt-5">
              <Button
                className="btn-main-color"
                onClick={signOnClick}
                isLoading={isLoading}
              >
                Doorgaan
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default WaiverPageV2;
